module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.windowWidth >= 800) ? _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "menuCon"
  }, [_c('a', {
    attrs: {
      "href": "./index.html"
    }
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 1 ? 'menuListAct' : ''
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.index))])])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 2 ? 'menuListAct' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.mouseOver(1)
      },
      "mouseleave": function($event) {
        return _vm.mouseLeave()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.about))]), _vm._v(" "), _c('ul', {
    staticClass: "menuListCon",
    class: _vm.tabTag == 1 ? 'menuListHover' : ''
  }, [_c('a', {
    attrs: {
      "href": "./about.html?id=1"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.synopsis))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=2"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.develop))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=3"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.honor))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=4"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.team))])])])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 3 ? 'menuListAct' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.mouseOver(2)
      },
      "mouseleave": function($event) {
        return _vm.mouseLeave()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.products))]), _vm._v(" "), _c('ul', {
    staticClass: "menuListCon",
    class: _vm.tabTag == 2 ? 'menuListTwoHover' : ''
  }, [_c('a', {
    attrs: {
      "href": "./productSpring.html"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.spring))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./productHardware.html"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.hardware))])])])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 4 ? 'menuListAct' : '',
    on: {
      "mouseenter": function($event) {
        return _vm.mouseOver(3)
      },
      "mouseleave": function($event) {
        return _vm.mouseLeave()
      }
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.technology))]), _vm._v(" "), _c('ul', {
    staticClass: "menuListCon",
    class: _vm.tabTag == 3 ? 'menuListHover' : ''
  }, [_c('a', {
    attrs: {
      "href": "./technology.html?id=1"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.echnicalAdvantages))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=2"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.productionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=3"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.inspectionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=4"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.workshopEnvironment))])])])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./contact.html"
    }
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 5 ? 'menuListAct' : ''
  }, [_c('p', [_vm._v(_vm._s(_vm.copyData.homeView.menuList.contact))])])])]), _vm._v(" "), _vm._m(1)])]) : _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "menuButton"
  }, [_c('img', {
    staticClass: "menuTab",
    attrs: {
      "src": require("../../assets/images/homeView/phoneMenu.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.maskTag = true
      }
    }
  }), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3)]), _vm._v(" "), (_vm.maskTag) ? _c('div', {
    staticClass: "mask",
    on: {
      "click": function($event) {
        _vm.maskTag = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.maskTag) ? _c('div', {
    staticClass: "mian"
  }, [_c('ul', {
    staticClass: "menuCon"
  }, [_c('a', {
    staticClass: "menuList",
    attrs: {
      "href": "./index.html"
    }
  }, [_c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 1 ? 'menuListAct' : ''
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.index))])]), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 2 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.menuListTag == 1 ? _vm.menuListTag = 0 : _vm.menuListTag = 1
      }
    }
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.about) + "\n      ")]), _vm._v(" "), (_vm.menuListTag == 1) ? _c('ul', {
    staticClass: "menuListCon"
  }, [_c('a', {
    attrs: {
      "href": "./about.html?id=1"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.synopsis))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=2"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.develop))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=3"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.honor))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./about.html?id=4"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.team))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 3 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.menuListTag == 2 ? _vm.menuListTag = 0 : _vm.menuListTag = 2
      }
    }
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.products) + "\n      ")]), _vm._v(" "), (_vm.menuListTag == 2) ? _c('ul', {
    staticClass: "menuListCon"
  }, [_c('a', {
    attrs: {
      "href": "./productSpring.html"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.spring))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./productHardware.html"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.hardware))])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "menuList",
    class: _vm.menuType == 4 ? 'menuListAct' : '',
    on: {
      "click": function($event) {
        _vm.menuListTag == 3 ? _vm.menuListTag = 0 : _vm.menuListTag = 3
      }
    }
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.technology) + "\n      ")]), _vm._v(" "), (_vm.menuListTag == 3) ? _c('ul', {
    staticClass: "menuListCon"
  }, [_c('a', {
    attrs: {
      "href": "./technology.html?id=1"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.echnicalAdvantages))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=2"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.productionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=3"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.inspectionEquipment))])]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "./technology.html?id=4"
    }
  }, [_c('li', {
    staticClass: "menuTab"
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.workshopEnvironment))])])]) : _vm._e(), _vm._v(" "), _c('a', {
    staticClass: "menuList",
    attrs: {
      "href": "./contact.html"
    }
  }, [_c('div', {
    class: _vm.menuType == 5 ? 'menuListAct' : ''
  }, [_vm._v(_vm._s(_vm.copyData.homeView.menuList.contact))])])])]) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "./index.html"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets//images/homeView/LOGO.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "language",
    attrs: {
      "href": "/cn/index.html"
    }
  }, [_c('p', [_vm._v("中/EN")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "./index.html"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../../assets/images/homeView/LOGO.png"),
      "alt": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "language",
    attrs: {
      "href": "/cn/index.html"
    }
  }, [_c('p', [_vm._v("中/EN")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-6f5d4b2e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Header/Header.vue
// module id = 18
// module chunks = 1 3 4 5 6 7